import { createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteVouchersPromocodesParams } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const deleteVouchersPromocodes = createAsyncThunk<
  void,
  DeleteVouchersPromocodesParams
>(
  "vouchers/deleteVouchersPromocodes",
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      await VouchersAPI.deleteVouchersPromocodes({
        voucherId,
        ...params,
      });
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while deleting voucher promocodes",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error("Error while deleting voucher promocodes", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
